(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);

/* ---------------------------------------------------------
   ProductForm
   Reads option selections (Color/Size/Style) directly from
   the swatches/inputs, looks up the matching variant in the
   product data, and authoritatively manages:
     - which variant ID is on the form
     - the Add to Cart button state
     - the quantity cap vs. stock
     - AJAX add + cart drawer open
   --------------------------------------------------------- */
class ProductForm {
  constructor(section) {
    this.section = section;
    this.form = section.querySelector('form[action*="/cart/add"]');
    this.button = section.querySelector('.product-form__cart-submit');
    this.buttonText = section.querySelector('[id^="AddToCartText-"]');
    this.quantityInput = section.querySelector('.product-form__quantity');
    this.variantSelect = section.querySelector('select[name="id"]');
    if (!this.form || !this.button || !this.quantityInput) return;

    this.addToCartText = this.button.dataset.addToCartText || 'Add to cart';
    this.soldOutText = this.button.dataset.soldOutText || 'Sold out';
    this.unavailableText = 'Unavailable';
    this.productData = null;
    this.isSubmitting = false;
    this._validateTimer = null;

    this.init();
  }

  async init() {
    this.bindEvents();
    this.validate();
    await this.loadProductData();
    this.validate();
  }

  async loadProductData() {
    const handle = this.section.dataset.handle;
    if (!handle) return;
    try {
      const res = await fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } });
      if (res.ok) this.productData = await res.json();
    } catch (e) {
      console.warn('ProductForm: could not load product data', e);
    }
  }

  bindEvents() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));

    ['input', 'change', 'blur'].forEach((evt) => {
      this.quantityInput.addEventListener(evt, () => this.validate());
    });

    // Catch every form input change (selects, radios, hidden inputs)
    this.form.addEventListener('change', (e) => {
      if (e.target === this.quantityInput) return;
      this.scheduleValidate();
    });

    // Catch swatch clicks (labels / buttons that don't fire change events)
    this.section.querySelectorAll('.selector-wrapper').forEach((wrapper) => {
      wrapper.addEventListener('click', () => this.scheduleValidate(150));
    });

    // Theme custom events
    ['variant:change', 'variantChange', 'product:variantChange', 'on:variant:change'].forEach((evt) => {
      this.section.addEventListener(evt, () => this.scheduleValidate());
      document.addEventListener(evt, () => this.scheduleValidate());
    });

    // DOM mutation safety net
    new MutationObserver(() => this.scheduleValidate()).observe(this.quantityInput, {
      attributes: true,
      attributeFilter: ['data-stock', 'max', 'data-inventory-managed']
    });
    if (this.variantSelect) {
      new MutationObserver(() => this.scheduleValidate()).observe(this.variantSelect, {
        attributes: true,
        attributeFilter: ['value'],
        subtree: true,
        childList: true
      });
    }
    // Watch for class changes on swatches (theme highlights selection via class)
    this.section.querySelectorAll('.selector-wrapper').forEach((wrapper) => {
      new MutationObserver(() => this.scheduleValidate()).observe(wrapper, {
        attributes: true,
        attributeFilter: ['class', 'aria-checked', 'data-selected'],
        subtree: true
      });
    });
  }

  scheduleValidate(delay) {
    clearTimeout(this._validateTimer);
    this._validateTimer = setTimeout(() => this.validate(), delay || 80);
  }

  // ----- Read the user's option selections from the DOM -----

  getSelectedOptionValues() {
    const wrappers = this.section.querySelectorAll('.selector-wrapper');
    if (wrappers.length === 0) return null;

    const values = [];
    wrappers.forEach((wrapper) => {
      // 1. Standard Shopify select
      const select = wrapper.querySelector('select.single-option-selector, select[id^="SingleOptionSelector-"], select');
      if (select) {
        values.push(select.value);
        return;
      }
      // 2. Standard Shopify radio buttons
      const checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        values.push(checkedRadio.value);
        return;
      }
      // 3. Selected swatch element with data-value
      const selectedSwatch = wrapper.querySelector(
        '.selected[data-value], .is-selected[data-value], .active[data-value], [aria-checked="true"][data-value]'
      );
      if (selectedSwatch) {
        values.push(selectedSwatch.getAttribute('data-value'));
        return;
      }
      // 4. Fallback: this theme renders the current value into a span
      const display = wrapper.querySelector('[class*="js-swatch-display--"]');
      if (display && display.textContent.trim()) {
        values.push(display.textContent.trim());
        return;
      }
      // 5. No selection detected for this option
      values.push(null);
    });

    return values;
  }

  findVariantByOptions(values) {
    if (!this.productData || !this.productData.variants || !values) return null;
    return this.productData.variants.find((variant) => {
      if (!variant.options || variant.options.length !== values.length) return false;
      return variant.options.every((opt, i) => opt === values[i]);
    }) || null;
  }

  /* Recompute which option values lead to an available variant given the
     CURRENT selection of other options. Disables the unreachable ones so
     the user can't pick a sold-out combination. The currently checked
     radio is left clickable to avoid dead-ending the form.            */
  updateSwatchAvailability() {
    if (!this.productData || !this.productData.variants) return;
    const wrappers = this.section.querySelectorAll('.selector-wrapper');
    const currentValues = this.getSelectedOptionValues() || [];

    wrappers.forEach((wrapper, optionIndex) => {
      const isReachable = (value) => {
        const hypothetical = currentValues.slice();
        hypothetical[optionIndex] = value;
        return this.productData.variants.some((v) =>
          v.available &&
          v.options &&
          v.options.length === hypothetical.length &&
          v.options.every((opt, i) => hypothetical[i] === null || opt === hypothetical[i])
        );
      };

      // Radio buttons (your fieldset case)
      wrapper.querySelectorAll('input[type="radio"]').forEach((radio) => {
        const reachable = isReachable(radio.value);
        const label = Array.from(wrapper.querySelectorAll('label')).find((l) => l.getAttribute('for') === radio.id);
        // Don't actually disable the currently checked radio (would clear the selection)
        if (!radio.checked) radio.disabled = !reachable;
        radio.classList.toggle('disabled', !reachable);
        if (label) label.classList.toggle('disabled', !reachable);
      });

      // Native <select>
      const select = wrapper.querySelector('select');
      if (select) {
        Array.from(select.options).forEach((opt) => {
          if (!opt.selected) opt.disabled = !isReachable(opt.value);
        });
      }
    });
  }

  getCurrentVariant() {
    if (!this.productData || !this.productData.variants) return null;

    // Primary path: build the variant from the user's actual swatch picks
    const values = this.getSelectedOptionValues();
    if (values && values.every((v) => v !== null)) {
      const variant = this.findVariantByOptions(values);
      if (variant) return variant;
    }

    // Fallback: use whatever variant ID the form currently holds
    if (this.variantSelect && this.variantSelect.value) {
      const id = parseInt(this.variantSelect.value, 10);
      return this.productData.variants.find((v) => v.id === id) || null;
    }

    return null;
  }

  syncVariantToForm(variant) {
    if (!variant || !this.variantSelect) return;
    if (this.variantSelect.value !== String(variant.id)) {
      this.variantSelect.value = String(variant.id);
    }
  }

  // ----- Validation / button state -----

  validate() {
    if (this.isSubmitting) return;

    let qty = parseInt(this.quantityInput.value, 10);
    if (isNaN(qty) || qty < 1) {
      qty = 1;
      this.quantityInput.value = 1;
    }

    this.updateSwatchAvailability();

    const variant = this.getCurrentVariant();

    // We have product data but no variant matched the selected options:
    // the user picked a combination that doesn't exist or is sold out
    if (this.productData && !variant) {
      this.setButtonState(false, this.unavailableText);
      return;
    }

    // Variant resolved → make sure the form points at it
    if (variant) {
      this.syncVariantToForm(variant);

      if (!variant.available) {
        this.setButtonState(false, this.soldOutText);
        return;
      }

      // Stock cap
      if (variant.inventory_management === 'shopify') {
        const stock = variant.inventory_quantity;
        this.quantityInput.dataset.stock = stock;
        this.quantityInput.dataset.inventoryManaged = 'true';
        this.quantityInput.setAttribute('max', stock > 0 ? stock : 1);

        if (stock <= 0) {
          this.setButtonState(false, this.soldOutText);
          return;
        }
        if (qty > stock) {
          this.quantityInput.value = stock;
          this.setButtonState(false, 'Only ' + stock + ' available');
          return;
        }
      }

      this.setButtonState(true, this.addToCartText);
      return;
    }

    // Product data not loaded yet — fall back to DOM hints
    if (this.variantSelect) {
      const opt = this.variantSelect.options[this.variantSelect.selectedIndex];
      if (opt && opt.disabled) {
        this.setButtonState(false, this.soldOutText);
        return;
      }
    }
    this.setButtonState(true, this.addToCartText);
  }

  setButtonState(enabled, text) {
    this.button.disabled = !enabled;
    this.button.classList.toggle('btn--sold-out', !enabled);
    if (this.buttonText) this.buttonText.textContent = text;

    // Keep the Shop Pay / Buy now button consistent
    const payment = this.section.querySelector('.shopify-payment-button');
    if (payment) payment.style.display = enabled ? '' : 'none';
  }

  // ----- Submit / AJAX -----

  async handleSubmit(event) {
    event.preventDefault();
    this.validate();
    if (this.button.disabled || this.isSubmitting) return;

    // Final safety check
    const variant = this.getCurrentVariant();
    if (variant) {
      if (!variant.available) { this.validate(); return; }
      if (variant.inventory_management === 'shopify') {
        const qty = parseInt(this.quantityInput.value, 10) || 1;
        if (variant.inventory_quantity <= 0 || qty > variant.inventory_quantity) {
          this.validate();
          return;
        }
      }
      this.syncVariantToForm(variant);
    }

    this.isSubmitting = true;
    this.setLoading(true);

    try {
      const formData = new FormData(this.form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await response.json();

      if (!response.ok) {
        this.showError(data.description || data.message || 'Could not add to cart');
        return;
      }

      await this.refreshCart();
      this.openCartDrawer();
    } catch (err) {
      console.error('Add to cart failed:', err);
      this.showError('Network error, please try again');
    } finally {
      this.isSubmitting = false;
      this.setLoading(false);
      this.validate();
    }
  }

  setLoading(isLoading) {
    const spinner = this.button.querySelector('.product-card__loading, .spinner-border, .spinner');

    if (isLoading) {
      this.button.classList.add('loading');
      this.button.setAttribute('aria-busy', 'true');
      this.button.disabled = true;
      if (spinner) spinner.style.display = 'inline-block';
      if (this.buttonText) this.buttonText.style.display = 'none';
    } else {
      this.button.classList.remove('loading');
      this.button.removeAttribute('aria-busy');
      this.button.disabled = false;
      if (spinner) spinner.style.display = 'none';
      if (this.buttonText) this.buttonText.style.removeProperty('display');
    }
  }

  showError(message) {
    let errorEl = this.section.querySelector('.product-form__error-message-ajax');
    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.className = 'product-form__error-message-ajax text-danger mt-2';
      errorEl.setAttribute('role', 'alert');
      const submitWrap = this.button.closest('.product-form__quantity-submit') || this.button.parentNode;
      submitWrap.appendChild(errorEl);
    }
    errorEl.textContent = message;
    clearTimeout(this._errTimer);
    this._errTimer = setTimeout(() => { if (errorEl) errorEl.remove(); }, 5000);
  }

  // ----- Cart drawer + count refresh -----

  async refreshCart() {
    try {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count, .header-cart-count, .cart-link__bubble-num').forEach((el) => {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.classList.remove('hide', 'hidden');
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch (e) {
      console.warn('Could not refresh cart:', e);
    }
  }

  openCartDrawer() {
    const cartDrawerEl = document.querySelector('cart-drawer, cart-notification');
    if (cartDrawerEl && typeof cartDrawerEl.open === 'function') { cartDrawerEl.open(); return; }

    const toggles = [
      '[data-cart-drawer-toggle]', '[data-drawer-target="cart"]', '[data-drawer-target="#cart"]',
      '[data-toggle="drawer-cart"]', '.js-drawer-open-cart', '.cart-toggle', '.header__cart-toggle',
      '[aria-controls="CartDrawer"]', '[aria-controls="cart-drawer"]', '[aria-controls="sidebar-cart"]'
    ];
    for (const selector of toggles) {
      const toggle = document.querySelector(selector);
      if (toggle) { toggle.click(); return; }
    }

    const drawers = ['.cart-drawer', '#CartDrawer', '#cart-drawer', '.drawer--cart', '.js-drawer-cart', '.mini-cart', '#mini-cart', '.cart-popup', '#sidebar-cart', '.sidebar-cart'];
    for (const selector of drawers) {
      const drawer = document.querySelector(selector);
      if (drawer) {
        drawer.classList.add('is-active', 'active', 'open', 'is-open', 'show', 'visible');
        document.body.classList.add('drawer-open', 'cart-open', 'js-drawer-open');
        return;
      }
    }

    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('drawer:open', { detail: { drawer: 'cart' } }));
    document.dispatchEvent(new CustomEvent('ajaxCart.afterCartLoad'));
  }
}

document.querySelectorAll('[data-section-type="product"]').forEach((section) => {
  new ProductForm(section);
});

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('data-phototview');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();
})();
